// Copyright (C) 2019 TANNER AG

import React from "react";
import * as PropTypes from "prop-types";
import Slider from "react-rangeslider";

export const RangeSlider = ({ min, max, step, value, onChange }) => (
	<Slider
		min={min}
		max={max}
		step={step}
		value={value}
		onChange={(value) => onChange(value)}
		tooltip={false}
	/>
);

RangeSlider.propTypes = {
	min: PropTypes.number,
	max: PropTypes.number,
	step: PropTypes.number,
	value: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired
};

RangeSlider.defaultProps = {
	min: 1,
	max: 2,
	step: 0.1
};



// WEBPACK FOOTER //
// ./src/tco/components/rangeslider.js